<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        :style="styleObject"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div v-else>
        <v-row>
          <div class="border">
            <h4
              id="titulo"
              class="text-center"
            >
              META
            </h4><br>
            <div
              id="valorFatSemanal"
              class="text-center"
            >
              {{ valorMeta }}
            </div>
          </div>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Comercial from '../../../../../services/comercialpersonalizacao'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowMeta',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      dados: [],
      vendedores: [],
      selectMes: [],
      selectAno: [],
      valorMeta: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
    }),

    created () {
      eventEmit.$on('update-dados-form', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-form', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (selectMes, selectAno, vendedores) {
        this.vendedores = vendedores
        this.selectMes = selectMes
        this.selectAno = selectAno

        this.valorMeta = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        this.showMeta()
      },

      async showMeta () {
        this.loading = true

        await Comercial.showMetaVendedor(this.selectMes, this.selectAno, this.vendedores, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorMeta = resposta.data.valorMeta.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Empresa não encontrada') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    .border {
      width: 27rem;
      margin: 0 0 0 1rem;
    }
  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  @media screen
  and (min-width: 1380px)
  and (max-width: 1901px) {
    .border {
      width: 16.5rem;
      margin: 0 0 0 -2rem
    }
  }

  @media screen
  and (min-width: 1902px) {
    .border {
      width: 21rem;
      margin: 0 0 0 -4rem;
    }
  }
</style>

<style lang="sass">
  .border
    border: inset
    width: 14.9rem

  #titulo
    background: gray

</style>
